"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promptData = exports.classes = void 0;
var classes = {
  mainContainer: 'policy-step-up-verification-tab-main-container',
  addPolicyFieldWrapper: 'sm-add-policy-field-wrapper'
};
exports.classes = classes;
var promptData = [{
  label: 'View',
  value: 'true'
}, {
  label: 'Manage',
  value: 'false'
}];
exports.promptData = promptData;